var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#DEB000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1095 13.8783C11.3998 13.8783 10 15.2781 10 16.9878V28.3458C10 29.7955 11.0398 30.4154 12.3096 29.7055L16.2389 27.5159C16.6588 27.286 17.3387 27.286 17.7487 27.5159L21.678 29.7055C22.9577 30.4054 23.9976 29.7955 23.9976 28.3458V16.9878C23.9976 15.2781 22.5978 13.8783 20.8881 13.8783H13.1095Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9962 24.4675C29.9962 25.9172 28.9564 26.5271 27.6866 25.8272L25.757 24.7474C25.597 24.6575 25.497 24.4875 25.497 24.3075V16.9888C25.497 14.4492 23.4274 12.3796 20.8878 12.3796H16.8185C16.4486 12.3796 16.1886 11.9897 16.3586 11.6697C16.8785 10.6799 17.9183 10 19.1081 10H26.8868C28.5965 10 29.9962 11.3998 29.9962 13.1095V24.4675Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.aac32829.svg";
export { ForwardRef as ReactComponent };